export default __webpack_public_path__ + "img/9efac16024c34179e9de8a9659feb975.svg";